import React, {useState, useEffect} from 'react'
import {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBTable,
    MDBTableBody,
    MDBTableHead,
    MDBAlert,
    MDBBadge,
    MDBBtn,
    MDBInput,MDBInputGroup
} from "mdbreact";
import {isAuth} from "../../../Utils/firebaseUtils";
import firebase from "../../../Config/firebase";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import Select from "react-select";
import classes from './PendingRequest.module.css'

const db = firebase.firestore()

const PendingRequest = (props) => {
    const [isLoaded, setIsLoaded] = useState(false)
    const [noRecord, setNoRecord] = useState(false)
    const [memberType, setMemberType] = useState("")
    const [rejectReason, setRejectReason] = useState('')
    const [rejectRequestID, setRejectRequestID] = useState("")
    const [pendingRequest, setPendingRequest] = useState([])

    useEffect(() => {
        getPendingRequest()
    }, [])

    const getPendingRequest = () => {
        db.collection('PendingVerification')
            .where("type", "==", "REVIEWING")
            .get()
            .then(docs => {
                if (!docs.empty) {
                    let allPendingVerification = []
                    docs.forEach(doc => {
                        allPendingVerification.push({
                            id: doc.id,
                            ...doc.data()
                        })
                    })
                    setPendingRequest(allPendingVerification)
                    setIsLoaded(true)
                } else {
                    setNoRecord(true)
                    setIsLoaded(true)
                }
            })
    }

    const acceptRequest = async (id) => {
        console.log(id)
        await fetch("/api/member/acceptRequest", {
            method: 'POST',
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({
                uid: props.auth.uid,
                verifyToken: id,
                memberType: memberType
            })
        }).then((res) => res.json()).then((finalResponse) => {
            if (finalResponse.success) {
                let newPendingRequest = pendingRequest.filter(data => data.id !== id)
                setPendingRequest(newPendingRequest)
            }
        })
    }

    const rejectRequest = async (id,rejectReason) => {
        await fetch("/api/member/rejectRequest", {
            method: 'POST',
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({
                uid: props.auth.uid,
                verifyToken: id,
                rejectReason: rejectReason
            })
        }).then((res) => res.json()).then((finalResponse) => {
            if (finalResponse.success) {
                let newPendingRequest = pendingRequest.filter(data => data.id !== id)
                setPendingRequest(newPendingRequest)
            }
        })
    }

    return (
        <MDBContainer>
            <MDBRow>
                <MDBCol xl={12} lg={12} md={12} sm={12} xs={12}>
                    <MDBTable responsive>
                        <MDBTableHead>
                            <tr>
                                <th>#</th>
                                <th>Type</th>
                                <th>Item</th>
                                <th>Requesting Email</th>
                                <th>Action</th>
                            </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                            {
                                isLoaded ?
                                    !noRecord ?
                                        pendingRequest.map((item, index) => {
                                            return (
                                                <tr key={item.id}>
                                                    <td>
                                                        {index + 1}
                                                    </td>
                                                    <td>
                                                        <MDBBadge>{item.type}</MDBBadge>
                                                    </td>
                                                    <td>
                                                        {item.uid}
                                                    </td>
                                                    <td>
                                                        {item.verifyEmail}
                                                    </td>
                                                    <td className={classes.OptionBtnGroup}>
                                                       <div className={classes.BtnGroup}>
                                                           <Select
                                                               options={[
                                                                   {label: "STUDENT", value: "STUDENT"},
                                                                   {label: "TEACHER", value: "TEACHER"}
                                                               ]}
                                                               value={{label: memberType, value: memberType}}
                                                               onChange={(e) => setMemberType(e.value)}/>

                                                           <button color={'success'}
                                                                   className={memberType === '' ? classes.OptionBtn : classes.SuccessOptionBtn}
                                                                   disabled={memberType === ''}
                                                                   onClick={() => acceptRequest(item.id)}
                                                           >
                                                               Accept
                                                           </button>
                                                       </div>


                                                        {
                                                            rejectRequestID === item.id ?
                                                               <div   className={classes.BtnGroup}>
                                                                   <input
                                                                       onChange={(e) => setRejectReason(e.target.value)}
                                                                       value={rejectReason}
                                                                   />
                                                                   <button color={'warning'}
                                                                           className={classes.ConfirmOptionBtn}
                                                                           onClick={() => rejectRequest(item.id)}
                                                                   >
                                                                       Confirm?
                                                                   </button>
                                                               </div>
                                                                :
                                                              <div className={classes.RejectBtnGroup}>
                                                                  <button color={'link'}
                                                                          className={classes.OptionBtn}
                                                                          onClick={() => setRejectRequestID(item.id, rejectReason)}
                                                                  >
                                                                      Reject
                                                                  </button>
                                                              </div>
                                                        }
                                                    </td>
                                                </tr>

                                            )
                                        })
                                        :
                                        <tr>
                                            <td colSpan={5}>
                                                <MDBAlert color='secondary'>
                                                    No Record
                                                </MDBAlert>
                                            </td>
                                        </tr>

                                    : ''
                            }
                        </MDBTableBody>
                    </MDBTable>

                </MDBCol>
            </MDBRow>
        </MDBContainer>
    )
}
const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)

export default enhance(withRouter(PendingRequest))